webpackJsonp([35783957827783],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = NewsletterSignup;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function NewsletterSignup() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'pa4-l' },
	    _react2.default.createElement(
	      'form',
	      { className: 'bg-light-gray mw7 center pa4 br2-ns ba b--black-10' },
	      _react2.default.createElement(
	        'fieldset',
	        { className: 'cf bn ma0 pa0' },
	        _react2.default.createElement(
	          'legend',
	          { className: 'pa0 f5 f4-ns mb3 black-80' },
	          'Sign up for our newsletter, to get updated as we add more goals'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'cf' },
	          _react2.default.createElement(
	            'label',
	            { className: 'clip', htmlFor: 'email-address' },
	            'Email Address'
	          ),
	          _react2.default.createElement('input', {
	            className: 'f6 f5-l input-reset bn fl black-80 bg-white pa3 lh-solid w-100 w-75-m w-80-l br2-ns br--left-ns',
	            placeholder: 'Your Email Address',
	            type: 'text',
	            name: 'email-address',
	            id: 'email-address'
	          }),
	          _react2.default.createElement('input', {
	            className: 'f6 f5-l button-reset fl pv3 tc bn bg-animate bg-black-70 hover-bg-black white pointer w-100 w-25-m w-20-l br2-ns br--right-ns',
	            type: 'submit',
	            value: 'Subscribe'
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(67);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _NewsletterSignup = __webpack_require__(42);
	
	var _NewsletterSignup2 = _interopRequireDefault(_NewsletterSignup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Card(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        border: 'thin solid #484848',
	        borderRadius: 10,
	        paddingLeft: 22,
	        paddingRight: 22,
	        margin: '20px 0'
	      },
	      className: 'shadow-hover'
	    },
	    children
	  );
	}
	
	var GOALS = [{
	  title: 'Find a partner',
	  link: '/goals/find-a-partner',
	  subtitle: "We've talked with dozens of dating experts, poured through books and online communities, and conducted our own research, to understand how you can be your best self and find a partner in the ever-digital dating scene of 2018.",
	  crediblePrediction: '75% of users who use our guide in addition to our plan find a partner within a year that they report being extremely satisfied with.'
	}, {
	  title: 'Be healthy',
	  link: '/goals/be-healthy',
	  subtitle: "We'll walk you step by step through the most tried and trued ways of achieving physical fitness, and arriving at a body you feel happy to inhabit.",
	  crediblePrediction: 'Depending on the track you take in our program, 80% achieve their target weight and 84% their target resting heart rate.'
	}, {
	  title: 'Live longer',
	  link: '/goals/live-longer',
	  subtitle: "Longevity is traditionally a difficult and painful goal, where you toil away for years without understanding your progress. We'll introduce you to cutting-edge techniques and methods for measuring progress so that you know you're on the right track within weeks of starting.",
	  crediblePrediction: ''
	}];
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'mw7 f5' },
	      _react2.default.createElement(
	        'p',
	        { className: '' },
	        'Welcome to Terminus, where we investigate and collect the best ways of achieving your',
	        _react2.default.createElement(
	          'span',
	          { className: 'b' },
	          ' biggest, most ambitious goals.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Our experts have spent hundreds of hours researching (and doing!) these goals, to find out what works, and what doesn\'t, so you can jump straight in.',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'link black hover-bg-light-gray underline', to: '/our-process' },
	          'Read more about our process and program.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'mw7 pt1' },
	      _react2.default.createElement(
	        'div',
	        { className: '' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Our goals'
	        )
	      ),
	      GOALS.map(function (_ref2) {
	        var title = _ref2.title,
	            subtitle = _ref2.subtitle,
	            link = _ref2.link,
	            crediblePrediction = _ref2.crediblePrediction;
	        return _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: link, style: { textDecoration: 'none', color: 'inherit' } },
	          _react2.default.createElement(
	            Card,
	            null,
	            _react2.default.createElement(
	              'p',
	              { className: 'serif', style: { fontSize: 20, fontWeight: 'bold' } },
	              title
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginTop: 10, fontSize: 16 } },
	              subtitle
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'b' },
	              crediblePrediction
	            )
	          )
	        );
	      }),
	      _react2.default.createElement(_NewsletterSignup2.default, null)
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-184abca97e6045bb9160.js